module.exports = __webpack_public_path__ + "svg/flags/Sao Tome and Principe.svg";